import { reactive, computed } from 'vue';
import type { Session } from '@supabase/supabase-js';
import { isSupabaseConfigured, supabase } from '@/lib/supabase';
import type { PortalRole, Profile } from '@/types/domain';

const state = reactive<{ ready:boolean; session:Session|null; profile:Profile|null; demoRole:PortalRole }>({
  ready:false,
  session:null,
  profile:null,
  demoRole:'candidate',
});

async function loadProfile() {
  if (!state.session?.user) { state.profile = null; return; }
  const { data, error } = await supabase.from('rf_profiles').select('*').eq('id', state.session.user.id).maybeSingle();
  if (error) throw error;
  state.profile = data as Profile | null;
}

export const authStore = {
  state,
  isConfigured: isSupabaseConfigured,
  isAuthenticated: computed(() => Boolean(state.session) || !isSupabaseConfigured),
  role: computed<PortalRole>(() => state.profile?.role || state.demoRole),
  displayName: computed(() => state.profile?.full_name || (state.demoRole === 'candidate' ? 'Siti Aminah' : 'Rina Wulandari')),
  async bootstrap() {
    if (!isSupabaseConfigured) { state.ready = true; return; }
    const { data } = await supabase.auth.getSession();
    state.session = data.session;
    await loadProfile().catch(() => { state.profile = null; });
    supabase.auth.onAuthStateChange((_event, session) => {
      state.session = session;
      void loadProfile();
    });
    state.ready = true;
  },
  async signIn(email:string,password:string) {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw error;
    await loadProfile();
  },
  async signUp(fullName:string,email:string,password:string) {
    const { error } = await supabase.auth.signUp({ email, password, options:{ data:{ full_name:fullName, app_source:'recruitflow' } } });
    if (error) throw error;
  },
  async signOut() { await supabase.auth.signOut(); state.profile = null; },
  setDemoRole(role:PortalRole) { state.demoRole = role; },
  async refreshProfile() { await loadProfile(); },
};
